module.exports = __webpack_public_path__ + "static/media/stars.6a40403a.svg";